import { useEffect, useState } from "react";
import styles from "./CustomSelect.module.css";
import { DropdownArrowIcon } from "../../assetLoader";
function CustomSelect({ value, onChange, id, options, style }) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  useEffect(() => {
    const hideDropdown = (e) => {
      if (e.target.id !== id) setIsDropdownVisible(false);
    };

    document.querySelector("#root").addEventListener("click", hideDropdown);
    return () => {
      document
        .querySelector("#root")
        .removeEventListener("click", hideDropdown);
    };
  }, []);
  return (
    <>
      <div
        className={styles.temp_select}
        id={id}
        onClick={(e) => {
          e.stopPropagation();
          setIsDropdownVisible((prevState) => !prevState);
        }}
        style={style}
      >
        {options[value].img && (
          <span className={styles.img}>{options[value].img()}</span>
        )}
        {options[value].label}
        <span className={styles.dropdown_arrow}>
          <span>{DropdownArrowIcon()}</span>
        </span>
      </div>
      {isDropdownVisible && (
        <ul className={styles.select_options}>
          {Object.keys(options).map((elem, index) => {
            return (
              <li
                key={options[elem].value}
                onClick={(e) => {
                  onChange(elem);
                  setIsDropdownVisible(false);
                }}
                style={{
                  borderBottom:
                    id === "select_1" && index === 2
                      ? "1px solid #e1e5e2"
                      : "none",
                }}
              >
                {options[elem].img && (
                  <span className={styles.img}>{options[elem].img()}</span>
                )}
                <span>{options[elem].label} </span>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
}
export default CustomSelect;
